<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="staff" slot-scope="staff">
          <div class="text-wrap">{{staff.first_name + ' ' + staff.last_name}}</div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
               @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              Edit
            </a>

            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
               @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>

          </div>
        </template>
      </a-table>
    </div>
    <edit-block @onEdited="handleAfteredit"/>
  </div>
</template>

<script>
import EditBlock from '@/components/hostel/manage/hostel-block/edit'
const columns = [
  { title: 'Block', width: 100, className: 'text-wrap', dataIndex: 'name', scopedSlots: { customRender: 'name' } },
  { title: 'Hostel', width: 100, className: 'text-center text-wrap', dataIndex: 'hostel.name', scopedSlots: { customRender: 'hostel.name' } },
  { title: 'Warden', width: 100, className: 'text-center text-wrap', dataIndex: 'staff', scopedSlots: { customRender: 'staff' } },
  { title: 'Description', width: 200, className: 'text-center text-wrap', dataIndex: 'description', scopedSlots: { customRender: 'description' } },
  { title: 'Total Rooms', width: 100, className: 'text-center', dataIndex: 'rooms_count', scopedSlots: { customRender: 'rooms_count' } },
  { title: 'Total Students', width: 100, className: 'text-center', dataIndex: 'enrolled_students_count', scopedSlots: { customRender: 'enrolled_students_count' } },
  { title: 'Actions', width: 200, className: 'text-right', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'BlockTable',
  components: {
    EditBlock,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    handleAfteredit() {
      this.$emit('updateTable')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this hostel?',
        content: `You are about to delete ${record.name}.`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/hostel/block/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
